// ADR 2.10.26s §1, §5 — how long the web waits, and what a wait is called.
//
// The first two numbers are rust-core's (`rust-core/src/config.rs`), mirrored
// rather than read from the wasm: 25.9.26f §3 keeps the transport off the
// facade, and no request should await a dynamic import to learn its deadline.
// `requestDeadline.test.ts` reads `config.rs` as text and fails on drift.

/** `FOREGROUND_READ_TIMEOUT_SECS` — every JSON call's total ceiling. */
export const FOREGROUND_TIMEOUT_MS = 20_000

/** `VOCAB_GENERATE_TIMEOUT_SECS` — `POST /vocab`'s per-request override. */
export const VOCAB_GENERATE_TIMEOUT_MS = 90_000

/**
 * The proof-of-work Worker solve (§4). Web-only: the phones' solve has no
 * ceiling to mirror. Six times the documented 2–5 s at difficulty 22 —
 * provisional until the low end is read from `device_enrolled.solve_ms`.
 */
export const POW_SOLVE_TIMEOUT_MS = 30_000

/** How long a launch waits on the network before painting the session it last confirmed (7.10.26ad §1). */
export const BOOT_RESUME_DEADLINE_MS = 500

const DIGIT = /\d/
const DIGITS_ONLY = /^\d+$/
const LONG_ID = 8

function templateSegment(segment: string, previous: string | undefined): string {
  // A share token is a bearer capability: it never reaches Sentry, digits or not.
  if (previous === 'shared') return ':token'
  if (DIGITS_ONLY.test(segment)) return ':id'
  if (segment.length >= LONG_ID && DIGIT.test(segment)) return ':id'
  return segment
}

/**
 * A request's route template (§5): origin and query dropped, ids replaced, so
 * one endpoint groups as one Sentry issue and no id or token is sent.
 */
export function routeTemplate(url: string): string {
  const path = new URL(url, 'http://template.invalid').pathname
  const segments = path.split('/')
  return segments.map((segment, index) => templateSegment(segment, segments[index - 1])).join('/')
}
